<div class="modal-header border-0 px-4 pt-4 pb-2">
  <div>
    <h4 class="modal-title fw-bold text-dark mb-1" style="text-transform: none !important;">
      Gestión de permisos
    </h4>
    <p class="text-muted small mb-0">
      Configurando accesos para el ID: <span class="badge bg-light text-dark border fw-semibold">{{ id }}</span>
    </p>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body px-4 pt-2 pb-3">
  
  <div class="mb-3">
    <label class="form-label text-muted small fw-bold text-uppercase tracking-wider mb-1" style="font-size: 0.75rem;">
      Buscar por usuario
    </label>
    <div class="input-group">
      <span class="input-group-text bg-white text-muted">
        <i class="fas fa-envelope"></i>
      </span>
      <app-search-autocomplete 
        [searchFunction]="search" 
        [displayKey]="'nombre'" 
        [secondaryDisplayKey]="'correo'"
        [placeholder]="'Buscar por: correo'" 
        [minLength]="3" 
        [debounceTimeMs]="500"
        (itemSelected)="realizarBusqueda($event)"
        class="form-control p-0">
      </app-search-autocomplete>
    </div>
  </div>

  <div class="mb-4">
    <label class="form-label text-muted small fw-bold text-uppercase tracking-wider mb-1" style="font-size: 0.75rem;">
      Buscar por grupo
    </label>
    <div class="input-group">
      <span class="input-group-text bg-white text-muted">
        <i class="fa fa-users"></i>
      </span>
      <app-groups 
        (idGroup)="onPick($event)" 
        class="form-control p-0">
      </app-groups>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-12">
      <app-paginacion 
        [currentPage]="currentPage" 
        [totalItems]="totalItems" 
        [selectedPageSize]="pageSize"
        [paginatedData]="currentItems" 
        [headers]="tableHeaders"
        [actions]="customActions"
        (pageChange)="onPageChange($event)" 
        (pageSizeChange)="onPageSizeChange($event)" 
        [loading]="spinner"
        data-tour="columna-acciones">
      </app-paginacion>
    </div>
  </div>

</div>

<div class="modal-footer border-0 px-4 pb-4 pt-0 d-flex justify-content-end gap-2">
  <button type="button" class="btn btn-light border text-secondary px-4 fw-medium" (click)="activeModal.close('Cerrar click')">
    Cerrar
  </button>
</div>